export const UNDERSTANDING_YOUR_DOG: Record<
	UnderstandingYourDogScreenNames,
	string
> = {
	UYD_INTRO: /*html*/ `
        <div>
        <h5>Routing</h5>
        <table>
            <thead>
            <tr>
                <th>Option(s)</th>
                <th>Next Route</th>
                <th>Next Screen</th>
            </tr>
            </thead>
            <tr>
            <td>N/A</td>
            <td>UNDERSTANDING_YOUR_DOG</td>
            <td>Q12</td>
            </tr>
        </table>
        <h5>Other info</h5>
        <p>
            <strong>INTRO</strong>
        </p>
        </div>
    `,

	Q12: /*html*/ `
        <div>
        <h5>Routing</h5>
        <table>
            <thead>
            <tr>
                <th>Option(s)</th>
                <th>Next Route</th>
                <th>Next Screen</th>
            </tr>
            </thead>
            <tr>
            <td>N/A</td>
            <td>UNDERSTANDING_YOUR_DOG</td>
            <td>Q13</td>
            </tr>
        </table>
        <h5>Other info</h5>
        <p>
            <strong>OPTIONAL</strong>
        </p>
        <p>See randomly selected question info below</p>
        </div>
    `,

	Q13: /*html*/ `
        <div>
        <h5>Routing</h5>
        <table>
            <thead>
            <tr>
                <th>Option(s)</th>
                <th>Next Route</th>
                <th>Next Screen</th>
            </tr>
            </thead>
            <tr>
            <td>N/A</td>
            <td>UNDERSTANDING_YOUR_DOG</td>
            <td>Q14</td>
            </tr>
        </table>
        <h5>Other info</h5>
        <p>
            <strong>OPTIONAL</strong>
        </p>
        </div>
    `,

	Q14: /*html*/ `
        <div>
        <h5>Routing</h5>
        <table>
            <thead>
            <tr>
                <th>Option(s)</th>
                <th>Next Route</th>
                <th>Next Screen</th>
            </tr>
            </thead>
            <tr>
            <td>N/A</td>
            <td>UNDERSTANDING_YOUR_DOG</td>
            <td>Q15</td>
            </tr>
        </table>
        <h5>Other info</h5>
        <p>
            <strong>OPTIONAL</strong>
        </p>
        </div>
    `,

	Q15: /*html*/ `
        <div>
        <h5>Routing</h5>
        <table>
            <thead>
            <tr>
                <th>Option(s)</th>
                <th>Next Route</th>
                <th>Next Screen</th>
            </tr>
            </thead>
            <tr>
            <td>At least one behaviour selected</td>
            <td>UNDERSTANDING_YOUR_DOG</td>
            <td>Q15_1</td>
            </tr>
            <tr>
            <td>No behaviour selected, "None of the above" or "Not sure"</td>
            <td>UNDERSTANDING_YOUR_DOG</td>
            <td>Q16</td>
            </tr>
        </table>
        <h5>Other info</h5>
        <p>
            <strong>OPTIONAL</strong>
        </p>
        </div>
    `,

	Q15_1: /*html*/ `
        <div>
        <h5>Routing</h5>
        <table>
            <thead>
            <tr>
                <th>Option(s)</th>
                <th>Next Route</th>
                <th>Next Screen</th>
            </tr>
            </thead>
            <tr>
            <td>N/A</td>
            <td>UNDERSTANDING_YOUR_DOG</td>
            <td>Q16</td>
            </tr>
        </table>
        <h5>Other info</h5>
        <p>
            <strong>OPTIONAL</strong>
        </p>
        </div>
    `,

	Q16: /*html*/ `
        <div>
        <h5>Routing</h5>
        <table>
            <thead>
            <tr>
                <th>Option(s)</th>
                <th>Next Route</th>
                <th>Next Screen</th>
            </tr>
            </thead>
            <tr>
            <td>N/A</td>
            <td>UNDERSTANDING_YOUR_DOG</td>
            <td>Q17</td>
            </tr>
        </table>
        <h5>Other info</h5>
        <p>
            <strong>OPTIONAL</strong>
        </p>
        <p>See randomly selected question info below</p>
        </div>
    `,

	Q17: /*html*/ `
        <div>
        <h5>Routing</h5>
        <table>
            <thead>
            <tr>
                <th>Option(s)</th>
                <th>Next Route</th>
                <th>Next Screen</th>
            </tr>
            </thead>
            <tr>
            <td>N/A</td>
            <td>RELATIONSHIP_WITH_YOUR_DOG</td>
            <td>RYD_INTRO</td>
            </tr>
        </table>
        <h5>Other info</h5>
        <p>
            <strong>OPTIONAL</strong>
        </p>
        <p>See randomly selected question info below</p>
        </div>
    `,
};
